import "./TopicStartegyBuilder.scss";

import { Box, Divider, Typography } from "@mui/material";

import CardHistory from "./CardHistory";
import React from "react";

const TopicStartegyHistory = () => {
  return (
    <Box className="startegy-main-container">
      <Box className="startegy-inner-container">
        <Box className="histroy-title-container">
          <Box className="history-title">
            <Typography
              variant="h4"
              sx={{
                color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
                textAlign: "center",
                fontFeatureSettings: "'liga' off, 'clig' off",
              }}
            >
              Topic Strategy Builder
            </Typography>
          </Box>
        </Box>
        <Divider
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}
        />
        <CardHistory con={false} nav={true} channel={false} ref={null} />
      </Box>
    </Box>
  );
};

export default TopicStartegyHistory;
